import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[750px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Anime%20style%20landscape%20illustration%20of%20epic%20fantasy%20world%20with%20floating%20islands%20and%20cherry%20blossom%20trees%2C%20vibrant%20sunset%20sky%20with%20warm%20orange%20and%20pink%20gradient%2C%20dramatic%20clouds%2C%20silhouette%20of%20adventurers%2C%20magical%20particles%20floating%2C%20anime%20background%20art%2C%20cinematic%20composition&width=1800&height=900&seq=hero-bg-01&orientation=landscape"
          alt="风车动漫 - 海量动漫在线观看"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/60 via-background-950/40 to-background-950" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="animate-fade-in-up">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 text-primary-300 text-xs font-medium mb-6 whitespace-nowrap">
            <i className="ri-sparkling-2-line mr-1.5"></i>
            海量动漫 · 高清在线 · 每日更新
          </span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-foreground-100 mb-4 animate-fade-in-up animation-delay-100 leading-tight">
          探索无尽的
          <span className="text-primary-500">动漫世界</span>
        </h1>

        <p className="text-base md:text-lg text-foreground-400 max-w-2xl mx-auto mb-8 animate-fade-in-up animation-delay-200 leading-relaxed">
          风车动漫拥有庞大动漫库，提供数千部作品在线观看，覆盖多样类型和年代，
          让每一位动漫爱好者尽情探索无尽精彩内容。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up animation-delay-300">
          <Link
            to="/category/action"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold rounded-full whitespace-nowrap cursor-pointer transition-all hover:scale-105 text-sm"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即开始追番
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-800/80 hover:bg-background-700 text-foreground-200 font-medium rounded-full whitespace-nowrap cursor-pointer transition-all text-sm border border-background-600/50"
          >
            <i className="ri-information-line mr-2"></i>
            了解更多
          </Link>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8 animate-fade-in-up animation-delay-400">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">
              5000+
            </p>
            <p className="text-xs text-foreground-500 mt-1">动漫作品</p>
          </div>
          <div className="w-px h-10 bg-foreground-700/30" />
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">
              30+
            </p>
            <p className="text-xs text-foreground-500 mt-1">覆盖类型</p>
          </div>
          <div className="w-px h-10 bg-foreground-700/30" />
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-secondary-400 font-heading">
              300万+
            </p>
            <p className="text-xs text-foreground-500 mt-1">活跃用户</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-fade-in-up animation-delay-500">
        <span className="w-8 h-8 flex items-center justify-center text-foreground-500 animate-bounce cursor-pointer">
          <i className="ri-arrow-down-s-line text-xl"></i>
        </span>
      </div>
    </section>
  );
}